import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Firebase } from '../../../Core'

import UserShield from '../../Components/UserShield'
import SettingsMenuButton from '../../Settings/SettingsMenuButton'
import HelpButton from '../../Settings/HelpButton'
import * as tutorialSelectors from '../../../Tutorial/tutorial.selectors'

/**
 *  Header for the battles
 */
const MisHeader = ({ currentUser, helpBtn, settingsBtn }) => (
  <div className="mis--header">
    <div className="mis--header__info">
      <UserShield shield={currentUser.colonyShield} />
    </div>
    <div className="mis--header__info">
      <span className="text username">{currentUser.colonyName}</span>
      <span className="text">
        <FormattedMessage
          id={`map.buildings.city_level.${currentUser.cityLevel ? currentUser.cityLevel : 1}`}
        />
      </span>
      <span className="text">{currentUser.name}</span>
      <span className="num">
        <span className="icon-settlers"></span>
        {currentUser.settlers}
      </span>
    </div>
    <div className="mis--header__position">
      <div className="text">
        <FormattedMessage id="ranking.position" />
      </div>
      <div className="text--position">{currentUser.position} º</div>
    </div>
    {!helpBtn && <HelpButton />}
    {!settingsBtn && <SettingsMenuButton />}
  </div>
)

const mapStateToProps = (state) => ({
  currentUser: tutorialSelectors.isTutorialMode(state)
    ? tutorialSelectors.getCurrentUser(state)
    : Firebase.selectors.getUserData(state),
})

MisHeader.propTypes = {
  currentUser: PropTypes.object,
  helpBtn: PropTypes.bool,
  settingsBtn: PropTypes.bool,
}

export default connect(mapStateToProps)(injectIntl(MisHeader))
